// firebase config
export const firebaseConfig = {
    apiKey: "AIzaSyDCFU0l6alS-m90ItPBWfampIb6AOpubFM",
    authDomain: "estore-169a2.firebaseapp.com",
    projectId: "estore-169a2",
    storageBucket: "estore-169a2.appspot.com",
    messagingSenderId: "1042858549378",
    appId: "1:1042858549378:web:6037883a7f34bb4bd3149b",
    measurementId: "G-STCXBG7MGJ"
};